import React, { Component } from 'react';
import { Configurations } from '../../Utils/Configurations';
import axios from 'axios';
import { Modal, ModalBody, ModalHeader } from "reactstrap";

class SendOrderEmail extends Component {

    constructor() {
        super();
        this.Configurations = new Configurations();

        this.handleInputChange = this.handleInputChange.bind(this);
        this.enviarEmail = this.enviarEmail.bind(this);
        this.enviarAnexo = this.enviarAnexo.bind(this);
        this.habilitaEnviarPorEmail = this.habilitaEnviarPorEmail.bind(this);
        this.validacaoEmail = this.validacaoEmail.bind(this);
        this.toggleModalBoleto = this.toggleModalBoleto.bind(this);

        this.state = {
            email: "",
            enviarAnexo: false,
            enviarPorEmail: false
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({ email: newProps.email });
    }

    handleInputChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    enviarAnexo() {
        this.setState({ enviarAnexo: !this.state.enviarAnexo });
    }

    enviarEmail() {
        this.setState({ isLoadingEmail: true }, () => {

            const body = { email: this.state.email, idUsuario: this.props.idSolicitante, enviarEmail: this.state.enviarAnexo };

            axios.post(`${this.Configurations.apiBasePath}/pedidos/${this.props.idPedido}/email`, body)
                .then(response => {
                    this.setState({
                        isLoadingEmail: false,
                        erroEmail: false,
                        emailEnviado: true
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.setState({
                        isLoadingEmail: false,
                        erroEmail: true,
                    });
                });
        })
    }

    validacaoEmail(inputEmail) {
        const _usuario = inputEmail.substring(0, inputEmail.indexOf("@"));
        const _dominio = inputEmail.substring(inputEmail.indexOf("@") + 1, inputEmail.length);

        if ((_usuario.length >= 1) &&
            (_dominio.length >= 3) &&
            (_usuario.search("@") === -1) &&
            (_dominio.search("@") === -1) &&
            (_usuario.search(" ") === -1) &&
            (_dominio.search(" ") === -1) &&
            (_dominio.search(".") !== -1) &&
            (_dominio.indexOf(".") >= 1) &&
            (_dominio.lastIndexOf(".") < _dominio.length - 1)) {
            return true;
        }
        else return false;
    }

    habilitaEnviarPorEmail() {
        this.setState({ enviarPorEmail: true })
    }

    toggleModalBoleto() {
        this.setState({
            email: '',
            emailEnviado: false,
            enviarPorEmail: false,
            erroEmail: false
        }, () => this.props.toggleEmail())
    }

    render() {
        const {
            opened,
        } = this.props;

        return (
            <Modal isOpen={opened}>
                <ModalHeader toggle={this.toggleModalBoleto}>Gerar boleto</ModalHeader>
                <ModalBody>
                    <div className='row py-2'>
                        <div className='col-12 text-center text-primary'>
                            <i><p className='m-0'>Boleto gerado com sucesso!</p></i>
                        </div>
                    </div>
                    {!this.state.enviarPorEmail && (
                        <div className='row text-center'>
                            <div className='col-12'>
                                <button className='btn btn-outline-primary' onClick={this.habilitaEnviarPorEmail}>Enviar por e-mail</button>
                            </div>
                        </div>
                    )}
                    {this.state.enviarPorEmail && (
                        <React.Fragment>
                            <div className="row">
                                <div className="col-12">
                                    <label>Email</label>
                                    <input type="email" className="form-control" required id="email" placeholder="" value={this.state.email} name="email" onChange={this.handleInputChange} />
                                </div>
                                <div className="col-12">
                                    <input type="checkbox" className="check-box" id="enviarCopiaAnexo" style={{ marginTop: 20 }} onChange={this.enviarAnexo} checked={this.state.enviarAnexo} />
                                    <label style={{ marginLeft: 7 }} htmlFor="enviarCopiaAnexo">enviar cópia do boleto por email</label>
                                </div>

                            </div>
                            <div className='row'>
                                <div className='col-12 text-center'>
                                    {this.state.isLoadingEmail ? (
                                        <div className="spinner-border text-primary" role="status" />
                                    ) : (
                                        <button className='btn btn-outline-success' onClick={this.enviarEmail} disabled={!this.validacaoEmail(this.state.email)}>Enviar</button>
                                    )}
                                    {(this.state.emailEnviado) && (
                                        <div className="col-12 text-center py-2">
                                            <i><span className="text-success">E-mail enviado com sucesso!</span></i>
                                        </div>
                                    )}
                                    {(!this.state.emailEnviado && this.state.erroEmail) && (
                                        <div className="col-12 py-2">
                                            <i><span className="text-danger">Não foi possível enviar o e-mail.</span></i>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </ModalBody>
            </Modal>
        )
    }
}

export default SendOrderEmail;